import { StateMapDisk } from '../state/state_map_disk.enum'
import type { State } from '../state/State.type'
import {
  decodePersistedStateData,
  encodePersistedStateBytes,
  type StateBytes,
} from '../state/persisted_state'

export function encodeWorkspacePersistedStateBytes(state: State): StateBytes {
  const encodedState = state.map.disk === StateMapDisk.Workspace || state.map.disk === StateMapDisk.Export
    ? {
        ...state,
        map: {
          ...state.map,
          disk: StateMapDisk.IndexedDB,
        },
      }
    : state

  return encodePersistedStateBytes(encodedState)
}

export function decodeWorkspacePersistedStateData(data: unknown): State {
  const state = decodePersistedStateData(data, StateMapDisk.IndexedDB)
  state.map.disk = StateMapDisk.Workspace
  return state
}
